export default function GraphNode(node, ctx, globalScale) {
    const label = node.name;
    const fontSize = 20/globalScale;
    ctx.font = `${fontSize}px Sans-Serif`;
    const textWidth = ctx.measureText(label).width / 2;
    const bckgDimensions = [textWidth, fontSize].map(n => n + fontSize * 0.2); // some padding
    const radius = bckgDimensions[1] > bckgDimensions[0] ? bckgDimensions[1] : bckgDimensions[0];
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // ctx.textWrap = true;
    ctx.fillStyle = node.color;
    
    ctx.beginPath(); 
    ctx.arc(node.x, node.y, radius, 0, 2 * Math.PI, false); 
    ctx.fill();
    ctx.fillStyle = 'black';
    ctx.fillText(label.replaceAll("[", "(").replaceAll("]", ")"), node.x, node.y);

}